import { render, staticRenderFns } from "./XModal.vue?vue&type=template&id=7fa43ba5&scoped=true&"
import script from "./XModal.vue?vue&type=script&lang=js&"
export * from "./XModal.vue?vue&type=script&lang=js&"
import style0 from "./XModal.vue?vue&type=style&index=0&id=7fa43ba5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa43ba5",
  null
  
)

export default component.exports